import apiBase from './ApiBase'
class ApiService {
  getAlerts = (startDate, endDate) => apiBase.get('/GetAlerts?start=' + startDate + (!!endDate ? `&end=${endDate}`: ''))
}

const AvsecAlertsAPIService = new ApiService()

export default AvsecAlertsAPIService
